import { Row, Button, Col, Alert, InputNumber } from 'antd';
import deepEqual from 'components/utils/deepEqual';
import React from 'react';
import { NumberChoice } from 'services/hitchit/types/Choices';

const ConfigureNumberField = ({
  choice,
  preference,
  savedPreference,
  onChange,
  onReset,
  onClear,
  onCancel,
  onSave,
}: {
  choice: NumberChoice;
  preference?: number;
  savedPreference?: number;
  onChange: (choice: number | undefined) => void;
  onReset: () => void;
  onClear: () => void;
  onCancel: () => void;
  onSave: () => void;
}): JSX.Element => {
  return (
    <Row gutter={[8, 8]} style={{ textAlign: 'left' }}>
      <Col span={24}>
        {choice ? (
          <InputNumber min={1} onChange={(value) => onChange(value as number)} value={preference} />
        ) : undefined}
      </Col>
      {choice.infoText && (
        <Col>
          <Alert
            style={{ padding: 16, margin: 16 }}
            message={choice.infoText}
            type="info"
            showIcon
          />
        </Col>
      )}
      <Col>
        <Button type="primary" disabled={deepEqual(savedPreference, preference)} onClick={onSave}>
          Save changes
        </Button>
      </Col>
      <Col>
        <Button disabled={deepEqual(savedPreference, preference)} type="ghost" onClick={onCancel}>
          Cancel change
        </Button>
      </Col>
      {choice.default && (
        <Col>
          <Button type="ghost" onClick={onReset}>
            Pick default
          </Button>
        </Col>
      )}
      <Col>
        <Button type="ghost" onClick={onClear}>
          Clear
        </Button>
      </Col>
    </Row>
  );
};

export default ConfigureNumberField;
